export const SHOW_ERROR_MODAL = 'GLOBAL:SHOW_ERROR_MODAL';
export const HIDE_ERROR_MODAL = 'GLOBAL:HIDE_ERROR_MODAL';
